'use client'
import type {
  StarFillType,
  StarsProps,
} from '@maestro/commerce-blocks/components/reviews/product-reviews.types'

import { useTranslations } from 'next-intl'
import React, { useMemo } from 'react'

import Star from '@maestro/commerce-blocks/components/reviews/star'

import '@maestro/commerce-blocks/components/reviews/styles/reviews.scss'

const Stars: React.FC<StarsProps> = (props: StarsProps) => {
  const { count, rating } = props
  const t = useTranslations('commerce-blocks.product')

  const starsArray = useMemo(() => {
    const roundedRating = Math.round(rating * 2) / 2
    const filledCount = Math.floor(roundedRating)
    const hasHalf = roundedRating % 1 !== 0
    return Array.from({ length: 5 }, (_, index) => {
      let fillType: StarFillType = 'star-empty'
      if (index < filledCount) {
        fillType = 'star-full'
      } else if (index === filledCount && hasHalf) {
        fillType = 'half'
      }
      return <Star key={`review-star-${index}`} fillType={fillType} />
    })
  }, [rating])

  const descriptiveAriaLabel =
    typeof count === 'number' && count >= 0
      ? t('reviews-rating-count', {
          rating: rating,
          count: count,
        })
      : t('reviews-rating', {
          rating: rating,
        })

  return (
    <>
      <div
        className="review-stars"
        role="img"
        aria-label={descriptiveAriaLabel}
      >
        {starsArray}
      </div>
      {typeof count === 'number' && count >= 0 && (
        <span className="review-stars__counter">({count})</span>
      )}
    </>
  )
}

export default Stars
